import React from "react";
import CircleLoader from "./circleLoader/circleLoader";

const TestCircleLoader = () => {
  return <CircleLoader />;
}

export default TestCircleLoader;